<script setup>
import { Link } from "@inertiajs/vue3";

const props = defineProps([
	"title",
	"subtitle",
	"date",
	"img",
	"tags",
	"id",
	"slug",
]);
</script>
<template>
	<!-- <Link :to="localePath(`/blog/${slug}`)"> -->
	<Link :href="route('post.one', slug)">
	<div class="relative group hover:animate-border inline-block backdrop-blur-[18px]
			 bg-gray-100 dark:bg-black text-black dark:text-white  border shadow-md  rounded-xl  border-solid border-[#00000000] mx-2 w-full p-3">
		<div
			class="relative flex-col flex md:flex-col gap-5 p- 5 
				rounded-lg justify-center w-full group-hover:opacity-100 transition-all duration-200 min-h-[300px] md:min-h-[300px] gap-y-4">
			<img fit="cover" :alt="title" :src="`${img}`" loading="lazy"
				class="rounded-lg object-cover md:w-full md:h-[240px]" cover />
			<div class="flex flex-col self-start justify-start w-full px-2 md:h-full">
				<p>
					{{ date.date }}
				</p>
				<h1 class="text-xl font-semibold">
					{{ title }}
				</h1>
				<p class="overflow-hidden opacity-70 line-clamp-1">
					{{ subtitle }}
				</p>
				<div class='flex justify-end w-full mb-4'>
					<v-btn :aria-label="__t('blog')" class="mt -10">
						<p class="px-5 tracking-normal text-white">
							{{ __t("read_more") }}
						</p>
					</v-btn>
				</div>
			</div>
		</div>
	</div>
	</Link>
</template>
